/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { getJsonExport, Locale } from '@typescript-kit/core';

import * as texts from '../text/authentication-de.text.json';

export const authenticationDeLocale: Locale = {
  texts: getJsonExport(texts)
};
